export enum CollaborationReviewStatus {
  Open = 1,
  InProgress = 2,
  Closed = 3,
  Overdue = 4,
}
